import React, { FC } from 'react';

interface IProps {
  width?: number;
  height?: number;
  fill?: string;
}

const IconCross: FC<IProps> = ({ width = 12, height = 12, fill = 'white' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4871 1.41287L10.5848 0.510585L6.07357 5.02181L1.56299 0.511229L0.660704 1.41351L5.17129 5.9241L0.659668 10.4357L1.56195 11.338L6.07357 6.82638L10.5858 11.3387L11.4881 10.4364L6.97586 5.9241L11.4871 1.41287Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconCross;
